import { withSideEffects as sideEffects } from 'redux-action-side-effects'
import { setTimeout } from 'timers'
const _ = require('lodash')

export const withSideEffects = (actionCreator, ...sideEffect) => (
  ...callArgs
) => {
  const sideEffectMapper = (effect) => {
    if (typeof effect === 'function') {
      let result = effect(...callArgs)
      return typeof result === 'function' ? result() : result
    } else if (_.isArray(effect)) {
      return _.map(effect, sideEffectMapper)
    }
    return effect
  }

  let mappedSideEffects = _.map(sideEffect, sideEffectMapper)
  return sideEffects(actionCreator(...callArgs), ...mappedSideEffects)
}

export const bounceSideEffectsStoreEnhancer = (next) => {
  const bouncer = (action, sideEffects) => {
    setTimeout(() => {
      const { store } = bounceSideEffectsStoreEnhancer
      store && _.forEach(sideEffects, (item) => store.dispatch(item))
    })
  }
  return (reducer, initialState) => {
    let store = next((state, action) => {
      const { meta: { sideEffects } = {} } = action.action || action
      action = sideEffects
        ? convertSideEffects(action, sideEffects, bouncer)
        : action
      return reducer(state, action)
    }, initialState)
    return store
  }
}

const convertSideEffect = (action, sideEffect) => {
  const meta = Object.assign({}, sideEffect.meta || {}, {
    bounced: true,
    origin: action.action || action,
  })
  return Object.assign({}, sideEffect, { meta })
}

const sideEffectFabric = (action, bouncer) => (sideEffect) => (dispatch) => {
  const sideEffects = _.isArray(sideEffect) ? sideEffect : [sideEffect]
  bouncer(
    action,
    _.map(sideEffects, (effect) => convertSideEffect(action, effect))
  )
}

function convertSideEffects(action, sideEffects, bouncer) {
  const functionalSideEffects = _.map(
    sideEffects,
    sideEffectFabric(action, bouncer)
  )
  const meta = Object.assign({}, action.meta, {
    sideEffects: functionalSideEffects,
  })
  return Object.assign({}, action, { meta })
}
